import React from 'react';
import { Redirect } from 'react-router-dom';
import BasicLayout from './layouts/BasicLayout';
import Login from './views/Login/Login';
import Sso from './views/Sso/Sso';
import FullLayout from './layouts/FullLayout';
// import Dashboard from './views/Dashboard/Dashboard';
import UserDashboard from './views/Dashboard/UserDashboard';
import User from './views/User/User';
import CreateUser from './views/User/CreateUser';
import EditUser from './views/User/EditUser';
import Permission from './views/Permission/Permission';
import CreatePermission from './views/Permission/CreatePermission';
import EditPermission from './views/Permission/EditPermission';
import ViewPermission from './views/Permission/ViewPermission';
import Role from './views/Role/Role';
import CreateRole from './views/Role/CreateRole';
import EditRole from './views/Role/EditRole';
import Setting from './views/Setting/Setting';
import CreateSetting from './views/Setting/CreateSetting';
import EditSetting from './views/Setting/EditSetting';
import ResetPassword from './views/ResetPassword/ResetPassword';
import ForgotPassword from './views/ForgotPassword/ForgotPassword';
import ListApps from './views/ListApps/index';
import ListAppsLog from './views/ListApps/logAppLogin';
import CreateApp from './views/ListApps/create';
import UpdateApp from './views/ListApps/update';
import Profile from './views/Profile/Profile';

const $routes = [
  {
    path: '/',
    layout: FullLayout,
    exact: true,
    component: () => <Redirect to="/login" />,
  },
  {
    path: '/login',
    layout: BasicLayout,
    component: Login,
    exact: true,
  },
  {
    path: '/apps-list',
    layout: FullLayout,
    component: UserDashboard,
    exact: true,
  },

  {
    path: '/user',
    layout: FullLayout,
    component: User,
    exact: true,
  },
  {
    path: '/profile',
    layout: FullLayout,
    component: Profile,
    exact: true,
  },
  {
    path: '/user/create',
    layout: FullLayout,
    component: CreateUser,
    exact: true,
  },
  {
    path: '/user/edit/:id',
    layout: FullLayout,
    component: EditUser,
    exact: true,
  },
  {
    path: '/apps',
    layout: FullLayout,
    component: ListApps,
    exact: true,
  },
  {
    path: '/apps-logging',
    layout: FullLayout,
    component: ListAppsLog,
    exact: true,
  },
  {
    path: '/apps/create',
    layout: FullLayout,
    component: CreateApp,
    exact: true,
  },
  {
    path: '/apps/update/:id',
    layout: FullLayout,
    component: UpdateApp,
    exact: true,
  },
  {
    path: '/permission',
    layout: FullLayout,
    component: Permission,
    exact: true,
  },
  {
    path: '/permission/create',
    layout: FullLayout,
    component: CreatePermission,
    exact: true,
  },
  {
    path: '/permission/edit/:id',
    layout: FullLayout,
    component: EditPermission,
    exact: true,
  },
  {
    path: '/permission/view/:id',
    layout: FullLayout,
    component: ViewPermission,
    exact: true,
  },
  {
    path: '/role',
    layout: FullLayout,
    component: Role,
    exact: true,
  },
  {
    path: '/role/create',
    layout: FullLayout,
    component: CreateRole,
    exact: true,
  },
  {
    path: '/role/edit/:id',
    layout: FullLayout,
    component: EditRole,
    exact: true,
  },
  {
    path: '/setting',
    layout: FullLayout,
    component: Setting,
    exact: true,
  },
  {
    path: '/setting/create',
    layout: FullLayout,
    component: CreateSetting,
    exact: true,
  },
  {
    path: '/setting/edit/:id',
    layout: FullLayout,
    component: EditSetting,
    exact: true,
  },
  {
    path: '/forgot-password',
    layout: BasicLayout,
    component: ForgotPassword,
    exact: true,
  },
  {
    path: '/reset-password',
    layout: BasicLayout,
    component: ResetPassword,
    exact: true,
  },
  {
    path: "/sso-callback",
    layout: BasicLayout,
    component: Sso,
    exact: true,
  },

];

export default $routes;
